// ─────────────────────────────────────────────────────────────────────
// Round 18 — persistent banner for a session opened with the BREAK-GLASS
// master password (login response `assisted: "master"`). Cannot be
// dismissed; shows who the session acts as and when it ends. Administration
// screens are refused server-side for such sessions; the banner makes the
// situation visible to whoever is at the keyboard.
// ─────────────────────────────────────────────────────────────────────
import React, { useEffect, useState } from "react";

function readAuth() {
    try { return JSON.parse(sessionStorage.getItem("authUser") || "null"); } catch { return null; }
}

export default function AssistedSessionBanner() {
    const [auth, setAuth] = useState(readAuth);
    const [now, setNow] = useState(Date.now());

    useEffect(() => {
        const tick = setInterval(() => { setAuth(readAuth()); setNow(Date.now()); }, 15000);
        const onStorage = () => setAuth(readAuth());
        window.addEventListener("storage", onStorage);
        return () => { clearInterval(tick); window.removeEventListener("storage", onStorage); };
    }, []);

    if (!auth || auth.assisted !== "master") return null;
    const expires = auth.assistedExpiresUtc || auth.accessExpiresUtc;
    const minutesLeft = expires ? Math.max(0, Math.round((new Date(expires).getTime() - now) / 60000)) : null;

    return (
        <div role="alert" style={{
            position: "sticky", top: 0, zIndex: 2000, background: "#b42318", color: "#fff",
            padding: "8px 16px", fontSize: 13, display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap",
        }}>
            <i className="ri-alarm-warning-line" style={{ fontSize: 18 }} />
            <strong>Master-password session</strong>
            <span>
                acting as <strong>{auth.name || auth.uid}</strong> (Emp ID {auth.uid}) — every action is recorded as
                "[MASTER-PASSWORD SESSION]" in the audit trail; administration pages are locked;
                {minutesLeft != null ? ` the session ends in ${minutesLeft} min and cannot be extended.` : " the session cannot be extended."}
            </span>
        </div>
    );
}
